fx.ns("models", class Shape extends fx.Model {

    constructor(data)
    {
        super(data);
    }

    get defaults()
    {
        return { color : "#ffffff", bgcolor : "#ffffff", side : "#ffffff" };
    }
});